import { render, staticRenderFns } from "./Equipe.vue?vue&type=template&id=d048183c&scoped=true&"
import script from "./Equipe.vue?vue&type=script&lang=js&"
export * from "./Equipe.vue?vue&type=script&lang=js&"
import style0 from "./Equipe.vue?vue&type=style&index=0&id=d048183c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d048183c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/build/repo/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VContainer,VFlex,VLayout})
